import { render, staticRenderFns } from "./ColumnFieldHelpIcon.vue?vue&type=template&id=2dd2ba16&scoped=true"
import script from "./ColumnFieldHelpIcon.vue?vue&type=script&lang=js"
export * from "./ColumnFieldHelpIcon.vue?vue&type=script&lang=js"
import style0 from "./ColumnFieldHelpIcon.vue?vue&type=style&index=0&id=2dd2ba16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd2ba16",
  null
  
)

export default component.exports